import React from 'react';
import { Select } from '@domain-group/fe-blueprint-ui/select';
import * as styles from './allhomes-search-sorting.style';
import { defaultSortOption, sortOptions } from './sort-options';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AllhomesSearchSorting = _ref => {
  var listingType = _ref.listingType,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? defaultSortOption : _ref$value,
    _ref$searchType = _ref.searchType,
    searchType = _ref$searchType === void 0 ? 'normal' : _ref$searchType,
    _ref$onSelect = _ref.onSelect,
    onSelect = _ref$onSelect === void 0 ? () => {} : _ref$onSelect;
  return ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX("div", {
    css: styles.label
  }, "Sort by:"), ___EmotionJSX("div", {
    css: styles.selectContainer
  }, ___EmotionJSX(Select, {
    css: styles.select,
    label: "search-sorting",
    options: sortOptions({
      listingType,
      searchType
    }),
    onChange: select => onSelect(select === null || select === void 0 ? void 0 : select.value),
    value: value,
    labelHidden: true,
    dropdownMaxHeight: 500
  })));
};